import gsap from 'gsap';
import { ISkeletonData, Spine } from "pixi-spine";
import * as PIXI from 'pixi.js';
import { AudioManager, Track } from "../../../AudioManager";
import { Color, LogGroup, Point, Rect, Safe, Size } from "../../../MyHelpers";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import { JackpotDisplayType, Settings } from "../../../Settings";
import { AwardOptionPosition } from "../../../api";
import { assertNotNullish } from "../../../debug";
import { ParseMonitors } from "../../../system/ParseMonitors";
import { IRewardOption } from "../../ScatterRandomAward/ScatterRandomAward";
import { SymbolCollection, SymbolTypeAnim } from "../../SpineSymbols/SymbolsCollection";
import { Sprite } from "../../Sprite/Sprite";
import { HoldingFeatureParams } from "./HoldingFeature";
import { S2_SpinnableReelsBigCanvas2 } from '../../SpinAnimation2/SpinnableReelsBigCanvas2';
import { S2_IReelConfig } from '../../SpinAnimation2/SpinnableReels';

export interface HoldingFeatureParamsPIXI extends HoldingFeatureParams
{
    readonly reelsCoverAnotherScreen : boolean;
    readonly gameName : string;
    readonly symbolCollection : SymbolCollection,
    readonly symbolTypeAnim : SymbolTypeAnim,
    readonly audio : AudioManager,
}

interface HoldingFeatureSymbolType {
    spineResourcesSkeleton : ISkeletonData,
    holdingFeatureTextures : PIXI.Texture[]
}


export class HoldingFeatureItemPIXI
{
    protected sprite: Sprite;
   // protected canvasSprite: CanvasSprite;
    protected canvasRect: Rect;
    protected rewardOption: IRewardOption;

    protected started: boolean;
    protected symbolPosition: Point;

    protected readonly scale: number = 1.10;

    protected spriteContainerPIXIAPP : PIXI.Container = null;
    protected symbolSpritePIXIAPP : PIXI.Container = null;
    protected viewPIXIAppTexture : PIXI.AnimatedSprite = null;
    protected symbolElement : PIXI.Container = null;
    protected pixelPosition: Rect = null;
    protected holdingFeatureTexture : PIXI.Texture[] = null;
    protected spineResourcesSkeleton : ISkeletonData = null;
    protected symbolTypeAnim : SymbolTypeAnim = null;
    protected spine : Spine = null;
    protected resid : ResourceIdentifier = null;
    readonly audio : AudioManager = null;
    readonly aspectFixY: number = 1;
    public constructor(pixelPosition: Rect, color: Color , holdingFeatureSymbolType : HoldingFeatureSymbolType, symbolTypeAnim: SymbolTypeAnim, resid : ResourceIdentifier , audio : AudioManager, aspectFixY: number = 1)
    {
        this.pixelPosition = pixelPosition;        
        this.symbolTypeAnim = symbolTypeAnim;
        if (symbolTypeAnim == SymbolTypeAnim.Sprites) {
            this.holdingFeatureTexture = holdingFeatureSymbolType.holdingFeatureTextures;
        } else {
            this.spineResourcesSkeleton = holdingFeatureSymbolType.spineResourcesSkeleton;
        }
        this.resid = resid;
        this.audio = audio;
        this.aspectFixY = aspectFixY;
    }

    public SetRewardOption(rewardOption: IRewardOption): void
    {
        this.rewardOption = rewardOption;       
    }
    
    public ViewPIXIAPP()
    {
        return this.spriteContainerPIXIAPP;
    }


    public Update(): void
    {
        //misisng update pixi symbol 
        //this.canvasSprite.Update();
    }

    public Start(rewardOption: IRewardOption , bonusMultiplier : number , awardShow : boolean , enableSound : boolean ): void
    {        
        this.SetRewardOption(rewardOption);
        this.started = true;

        //fix misisng gsap and anim symbol 1 time 
        this.spriteContainerPIXIAPP.visible = true;
        //this.symbolElement.scale.set(this.scale);
        let scaleSpineHide = {
            scaleX : this.symbolElement.scale.x,
            scaleY : this.symbolElement.scale.y * this.aspectFixY
        }

        

        gsap.to(scaleSpineHide, {
                duration: 0.5,
                onComplete :()=>{
                    this.spine?.state?.setAnimation(0,"winSymbol",false);
                    this.viewPIXIAppTexture?.play(); 
                    if(enableSound == true)this.audio.Play(this.resid.ScopedResourceName("holdingFeatureAnim-Track"), true);                       
                },
                onUpdate:()=>{
                    this.symbolElement.scale.set(scaleSpineHide.scaleX,scaleSpineHide.scaleY);
                } ,
                scaleX: this.scale,
                scaleY : this.scale * this.aspectFixY
            });        


        if (this.symbolTypeAnim == SymbolTypeAnim.Spine) {
            this.ResetValueContainerSpine();          
            this.rewardOption.DrawToSpine(this.spine);
            if(bonusMultiplier > 1 ) this.ShowMultiplierSpine(bonusMultiplier , awardShow)
        } else {
            this.rewardOption.DrawToPIXI(this.symbolSpritePIXIAPP as PIXI.AnimatedSprite, null, null);
            if (bonusMultiplier > 1) this.ShowMultiplier(bonusMultiplier)
        }
        
       
    }

    protected ResetValueContainerSpine(){        
        let spineChildrens = this.spine.children as PIXI.Container[];
        let valueContainer = spineChildrens.find(container => container.name == "value");
        if (valueContainer) {
            valueContainer.children.forEach(ele => {               
                ele.removeFromParent();
                ele.destroy();               
            })
        }
    }

    protected containerAward : PIXI.Container = null;
    protected ShowMultiplierSpine(bonusMultiplier: number , awardShow : boolean) {
       

        let strValueMultiplier = this.rewardOption.MultiplierAward(bonusMultiplier);

        let valueContainer = this.spine.children.find(container => container.name == "value") as PIXI.Container;
        if (valueContainer) {
            let containerAward = valueContainer.children.find(ele=>ele.name = "containerAward");
            gsap.to(containerAward, {
                delay: 1.5, alpha: 0, duration: 0.5, 
                onStart: () => {
                    this.audio.Play(this.resid.ScopedResourceName("scatterAwardChangeAward-Track"), true);
                },
                onComplete: () => {
                    this.ResetValueContainerSpine();
                    this.rewardOption.DrawToSpine(this.spine, null, strValueMultiplier, bonusMultiplier , awardShow);

                    gsap.to(containerAward, {
                        alpha: 1, duration: 0.5, onComplete: () => {
                            containerAward = null;
                            strValueMultiplier = null;
                            this.holdingElementFeatureEndCallback?.();                            
                        }
                    });
                }
            });
        }

    }

    protected ShowMultiplier(bonusMultiplier: number) {
        let strValueMultiplier = this.rewardOption.MultiplierAward(bonusMultiplier);


        let valueCanvas = this.symbolSpritePIXIAPP.parent.getChildByName("SRAvalue", true) as PIXI.Text;
        let shadowCanvas = this.symbolSpritePIXIAPP.parent.getChildByName("SRAshadowText", true) as PIXI.Text;

        gsap.to(valueCanvas, {
            delay: 0.5, alpha: 0, duration: 0.5,
            onStart: () => {
                this.audio.Play(this.resid.ScopedResourceName("scatterAwardChangeAward-Track"), true);
            },
            onComplete: () => {
                //this.rewardOption.DrawToPIXI(this.symbolSpritePIXIAPP as PIXI.AnimatedSprite, null, strValueMultiplier);
                gsap.to(valueCanvas, {
                    alpha: 1, duration: 0.5, onComplete: () => {

                    }
                });
            }
        });


        gsap.to(shadowCanvas, {
            delay: 0.5, alpha: 0, duration: 0.5, onComplete: () => {
                if (this.symbolTypeAnim == SymbolTypeAnim.Sprites) {
                    
                    this.rewardOption.DrawToPIXI(this.symbolSpritePIXIAPP as PIXI.AnimatedSprite, null, strValueMultiplier, bonusMultiplier);
                } else {
                    this.ResetValueContainerSpine();
                    this.rewardOption.DrawToSpine(this.spine, new Size(this.spine.spineData.width, this.spine.spineData.height), strValueMultiplier, bonusMultiplier ); 
                }
                gsap.to(shadowCanvas, {
                    alpha: 1, duration: 0.5, onComplete: () => {
                        this.holdingElementFeatureEndCallback?.();
                    }
                });
            }
        });

    }

    public holdingElementFeatureEndCallback : HoldingElementFeatureEndCallback = null;

    public Started(): boolean
    {
        return this.started;
    }

    public Stop(): void
    {
        this.started = false;        
        //this.spriteContainerPIXIAPP.visible = false;           
        //this.symbolElement.scale.set(1);             
    }

    public CreatePIXIAPP() {
        this.spriteContainerPIXIAPP = new PIXI.Container();
        this.spriteContainerPIXIAPP.width = this.pixelPosition.width;
        this.spriteContainerPIXIAPP.height = this.pixelPosition.height;
        this.spriteContainerPIXIAPP.name = "spriteContainerPIXIAPP";
        this.spriteContainerPIXIAPP.x = this.pixelPosition.x;
        this.spriteContainerPIXIAPP.y = this.pixelPosition.y;
        this.spriteContainerPIXIAPP.visible = false;

        this.symbolElement = new PIXI.Container();
        this.symbolElement.width = this.pixelPosition.width;
        this.symbolElement.height = this.pixelPosition.height;
        this.symbolElement.accessibleChildren = true;
        this.symbolElement.accessible = true;
        this.symbolElement.name = 'symbol';
        this.symbolElement.pivot.set(this.pixelPosition.width / 2, this.pixelPosition.height / 2);
        this.symbolElement.position.set(this.pixelPosition.width / 2, this.pixelPosition.height / 2);
        this.spriteContainerPIXIAPP.addChild(this.symbolElement);

        this.symbolSpritePIXIAPP = new PIXI.Container();
        this.symbolSpritePIXIAPP.name = "symbolcontainerAnimatedSprited";
        this.symbolElement.addChildAt(this.symbolSpritePIXIAPP, 0);

        if (this.symbolTypeAnim == SymbolTypeAnim.Sprites) {
            this.viewPIXIAppTexture = new PIXI.AnimatedSprite(this.holdingFeatureTexture);
            this.viewPIXIAppTexture.anchor.set(0.5, 0.5);
            //this.viewPIXIAppTexture.width = this.pixelPosition.width,
            //this.viewPIXIAppTexture.height = this.pixelPosition.height; 
            //this.viewPIXIAppTexture.pivot.set(this.pixelPosition.width/2,this.pixelPosition.height/2);

            let scaleWidth = this.pixelPosition.width / this.viewPIXIAppTexture.width;
            let scaleHeight = this.pixelPosition.height / this.viewPIXIAppTexture.height
            let scale = Math.min(scaleWidth, scaleHeight);
            this.viewPIXIAppTexture.width = this.viewPIXIAppTexture.width * scale;
            this.viewPIXIAppTexture.height = this.viewPIXIAppTexture.height * scale


            this.viewPIXIAppTexture.position.set(this.pixelPosition.width / 2, this.pixelPosition.height / 2);
            this.viewPIXIAppTexture.loop = false;
            this.symbolSpritePIXIAPP.addChild(this.viewPIXIAppTexture);

            scaleHeight = null;
            scaleWidth = null;
            scale = null;

            //create container for SRA value 				
            let shadowText = new PIXI.Text('');
            shadowText.anchor.set(0.5);
            shadowText.x = Math.round((this.pixelPosition.width) / 2);
            shadowText.y = Math.round(this.pixelPosition.height / 2);
            shadowText.name = "SRAshadowText";
            this.symbolElement.addChildAt(shadowText, 1);

            //create container for SRA value 				

            let value = new PIXI.Text('');
            value.anchor.set(0.5);
            value.x = Math.round((this.pixelPosition.width) / 2);
            value.y = Math.round(this.pixelPosition.height / 2);
            value.name = "SRAvalue";
            this.symbolElement.addChildAt(value, 2);


            // create a new Sprfite from an image path.
            let jpImg = new PIXI.Sprite();
            jpImg.anchor.set(0.5);
            jpImg.width = this.pixelPosition.width / 2;
            jpImg.height = this.pixelPosition.height / 5;
            jpImg.x = Math.round((this.pixelPosition.width) / 2);
            jpImg.y = Math.round(this.pixelPosition.height / 2);
            jpImg.name = "SRAjackpot";
            this.symbolElement.addChildAt(jpImg, 3);
        }
        else {
            this.spine = new Spine(this.spineResourcesSkeleton);

            const scaleX = this.pixelPosition.width / this.spine.spineData.width;
            const scaleY = this.pixelPosition.height / this.spine.spineData.height
            const scale = Math.min(scaleX, scaleY);
            this.spine.scale.set(scale);

            const scaledWidth = this.spine.spineData.width * scale;
            const scaledHeight = this.spine.spineData.height * scale;

            this.spine.position.x = Math.round((this.pixelPosition.width  - scaledWidth) / 2);
            this.spine.position.y = Math.round((this.pixelPosition.height - scaledHeight) / 2);
            this.symbolSpritePIXIAPP.addChild(this.spine);
        }       
    }


    public Destroy()
    {
        this.holdingElementFeatureEndCallback = null;

        this.spriteContainerPIXIAPP?.destroy();
        this.spriteContainerPIXIAPP = null;

        this.symbolElement?.destroy();
        this.symbolElement = null;

        this.symbolSpritePIXIAPP?.destroy(); 
        this.symbolSpritePIXIAPP = null;
        
        Safe(() => this.spine?.destroy())
        this.spine = null;
        
    }
}


export type HoldingFeatureEndCallback = () => void;
export type HoldingElementFeatureEndCallback = () => void;

export class HoldingFeaturePIXIApp
{
    protected params: HoldingFeatureParamsPIXI;
    protected resid: ResourceIdentifier;
    protected logGroup: LogGroup;

   // protected view: HTMLElement;

    //protected spinnableReels: SpinnableReels; 

    protected holdingItems: HoldingFeatureItemPIXI[][] = [];
    protected flatHoldingItems: HoldingFeatureItemPIXI[] = [];

    protected sprite: Sprite;
    // TODO convert to map?
    protected awardOptions: IRewardOption[] = [];

    protected viewPIXIApp : PIXI.Container = null;
    

    protected audio : AudioManager = null;
    public constructor(params: HoldingFeatureParamsPIXI)
    {
        this.params = params;

        this.resid = params.resid.Add("HoldingFeature");
        this.logGroup = params.logGroup.Add("HoldingFeature");
        this.audio = params.audio;
        //this.spinnableReels = params.spinnableReels;

       

        // this.viewPIXIApp = new PIXI.Container()
		// this.viewPIXIApp.name="holdingfeatureViewPIXIAPP";		
        // if(this.params.reelsCoverAnotherScreen == false) this.viewPIXIApp.y = Settings.ScreenHeight * (Settings.Screens -1);		
		// this.viewPIXIApp.interactive = true;
		// this.viewPIXIApp.interactiveChildren = true;

        // let viewPIXIAppTexture =  new PIXI.Sprite(PIXI.Texture.WHITE);		
		// viewPIXIAppTexture.width = Scale.W(1920),
		// viewPIXIAppTexture.height = Scale.H(1080);
        // this.viewPIXIApp.addChild(viewPIXIAppTexture);


    }

    protected readonly symbolsByJackpot = {
        [JackpotDisplayType.RapidDiamondPot]: ["SRA"],
        [JackpotDisplayType.PlayCityLink]: ["SRA"],
        [JackpotDisplayType.RapidDiamondPotStep]: ["SRA"],
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager): void {
        // let symbolPath = this.params.gameResourcesBasePath + "symbol";

        // //use for change for now the symbol Anim for Holding Feature
        // if (this.symbolsByJackpot[Settings.JackpotDisplayType]?.includes("SRA")) {
        //     symbolPath = this.params.gameResourcesBasePath + "SymbolJackpots/" + Settings.JackpotDisplayType + "/symbols2/symbol";
        // }
        // // TODO share sprite, if its loaded from common?
        // resourceManager.Add(new SpriteResource(symbolPath, this.resid.Add("itemsprite"), true, this.logGroup.Add("itemsprite"), true));
        // symbolPath = null;
        //this.audio.AddTrack(new Track(`${Settings.ResourcesFolder}multigame/slot/common/resources/tracks/bonusMultiplierShow${Settings.audioFormat}`, this.resid.Add("ShowMultiplier-Track"),true));
        this.audio.AddTrack(new Track(`${Settings.ResourcesFolder}multigame/slot/${this.params.gameName}/resources/HoldAndSpin/tracks/holdingFeatureAnim${Settings.audioFormat}`, this.resid.Add("holdingFeatureAnim-Track"),false));
        this.audio.AddTrack(new Track(`${Settings.ResourcesFolder}multigame/slot/common/resources/ScatterRandomAward/tracks/scatterAwardChangeAward${Settings.audioFormat}`, this.resid.Add("scatterAwardChangeAward-Track"),true));
    }

    protected holdingFeatureTextures : PIXI.Texture [] = [];
    protected aspectFixY: number = 1;
    public async ResourcesLodaded(resourceManager: IReadOnlyResourceManager, awardOptions: IRewardOption[]): Promise<void> {
        this.awardOptions = awardOptions;

        this.aspectFixY = ParseMonitors().AspectFixY;
        //let pixiSprite = resourceManager.Get<PixiSpriteResource>(`ScreenAll-Multigame-${this.params.gameName}-Symbol-SRA`).sprite;        

        if (this.params.spinnableReels)
        {
            this.UpdateReels(this.params.spinnableReels);
        }
    }

    protected reelConfig: S2_IReelConfig[] = null;
    public UpdateReels(spinnableRees: S2_SpinnableReelsBigCanvas2)
    {
        // this.flatHoldingItems?.forEach(item => item.Destroy());
        this.flatHoldingItems = [];

        this.holdingItems?.forEach(holdingItemReel => holdingItemReel?.forEach(holdingItem => holdingItem.Destroy()));
        this.holdingItems = [];

        this.reelConfig = spinnableRees.GetReelConfig();

        for (let reelIndex = 0; reelIndex < this.reelConfig.length; reelIndex++)
        {
            for (let symbolIndex = 0; symbolIndex < this.reelConfig[reelIndex].Height; symbolIndex++)
            {
                let symbolRect = spinnableRees.GetAbsoluteSymbolRectReelRow(reelIndex, symbolIndex);
                

                let holdingItem: HoldingFeatureItemPIXI = new HoldingFeatureItemPIXI(                   
                    new Rect(symbolRect.x,symbolRect.y,spinnableRees.GetSymbolSize().Width, spinnableRees.GetSymbolSize().Height),
                    null,
                    {
                        spineResourcesSkeleton : this.params.symbolTypeAnim == SymbolTypeAnim.Spine ? this.params.symbolCollection.symbolCollectionMap.get("Symbol_SRA").spineResources : null,
                        holdingFeatureTextures :  this.params.symbolTypeAnim == SymbolTypeAnim.Sprites ? this.params.symbolCollection.symbolCollectionMap.get("Symbol_SRA").spritesResources : null,
                    },
                    this.params.symbolTypeAnim,
                    this.resid,
                    this.audio,
                    this.aspectFixY
                );

                //holdingItem.CreatePIXIAPP();

                holdingItem.SetRewardOption(this.awardOptions.random());

                holdingItem.holdingElementFeatureEndCallback = () => 
                {
                    this.holdingFeatureEndCallback();      
                }

                if (!this.holdingItems)
                {
                    this.holdingItems = [];
                }

                if (!this.holdingItems[reelIndex])
                {
                    this.holdingItems[reelIndex] = [];
                }

                this.holdingItems[reelIndex].push(holdingItem);
                this.flatHoldingItems.push(holdingItem);
            }
        }
    }

    public SetAwardOptions(awardOptions: IRewardOption[]): void
    {
        this.awardOptions = awardOptions;
    }

    public Start(featureResult: AwardOptionPosition[], bonusMultiplier: number, awardShow: boolean , enableSound : boolean = true)
    {        
        assertNotNullish(featureResult, "Can't show scatter in holding feature, featureResult is null");
        for (const scatterPosition of featureResult) {
            
            let holdingItem = this.holdingItems[scatterPosition.Reel][scatterPosition.ReelOffset];

            let awardOption = this.awardOptions.find(ro => ro.Name() == scatterPosition.AwardOption.AwardName);
            assertNotNullish(awardOption, `Can't show scatter in holding feature, can't find award ${scatterPosition.AwardOption.AwardName}`);

            holdingItem.Start(awardOption, bonusMultiplier, awardShow , enableSound); 
        };
    }

    //its for play 1 by 1 
    public StartShowBonusScatter(featureResult: AwardOptionPosition, bonusMultiplier: number, awardShow: boolean)
    {      
        assertNotNullish(featureResult, "Can't show scatter in holding feature, featureResult is null");
        let holdingItem = this.holdingItems[featureResult.Reel][featureResult.ReelOffset];

        let awardOption = this.awardOptions.find(ro => ro.Name() == featureResult.AwardOption.AwardName);
        assertNotNullish(awardOption, `Can't show scatter in holding feature, can't find award ${featureResult.AwardOption.AwardName}`);

        holdingItem.Start(awardOption, bonusMultiplier, awardShow , true);
    }

    public Stop()
    {
        //let windowSymbolSize: Size = this.params.spinnableReels.GetWindowSymbolSize();

        for (let reel = 0; reel < this.holdingItems.length; reel++)
        {
            for (let sym = 0; sym < this.holdingItems[reel].length; sym++)
            {
                this.holdingItems[reel][sym].Stop();
            }
        }
    }
   
    public Update(): void
    {
        // TODO only update visible items?
        for (let i = 0; i < this.flatHoldingItems.length; i++)
        {
            this.flatHoldingItems[i].Update();
        }
    }

    public Hide(): void
    {
        //missing hide view 
        // SetStyles(this.view, {
        //     display: "none"
        // });
    }

    public ViewPIXIAPP(){
        return this.viewPIXIApp;
    }

    public CreatePIXIAPP(){      
        //this.holdingItems = [];  
        //this.flatHoldingItems = [];
        this.viewPIXIApp = new PIXI.Container()
		this.viewPIXIApp.name="holdingfeatureViewPIXIAPP";		
        //if(this.params.reelsCoverAnotherScreen == false) this.viewPIXIApp.y = Settings.ScreenHeight * (Settings.Screens -1);		
		//this.viewPIXIApp.interactive = true;
		//this.viewPIXIApp.interactiveChildren = true;

        assertNotNullish(this.reelConfig, "Reel config must be set");

        for (let reelIndex = 0; reelIndex < this.reelConfig.length; reelIndex++)
        {
            for (let symbolIndex = 0; symbolIndex < this.reelConfig[reelIndex].Height; symbolIndex++)
            {              
                this.holdingItems[reelIndex][symbolIndex].CreatePIXIAPP();
                this.viewPIXIApp.addChild(this.holdingItems[reelIndex][symbolIndex].ViewPIXIAPP());               
            }
        }
    }

    public Destroy(){

        for (let reelIndex = 0; reelIndex < this.reelConfig.length; reelIndex++)
        {
            for (let symbolIndex = 0; symbolIndex < this.reelConfig[reelIndex].Height; symbolIndex++)
            {              
                this.holdingItems[reelIndex][symbolIndex].Destroy();                
            }
        }

        this.flatHoldingItems = [];
        this.holdingItems = [];
    }


    public holdingFeatureEndCallback : HoldingFeatureEndCallback = null;
}
